<template>
    <div class="text-center">
        <v-dialog
        v-model="myobShipmentSchemaModal"
        scrollable
         width="900">
            <v-card>
                <v-card-title>
                    <span>Shipment Schema</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <!-- PAYLOAD -->
                        <pre>{{ schema }}</pre>
                    </v-container>
                </v-card-text>
                <v-card-actions class="pb-3">
                    <v-spacer></v-spacer>

                    <v-btn small @click="$emit('myobShipmentSchemaModalClose')">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>
.v-dialog__container {
    display: unset;
}
</style>

<script>

export default {

    props:{
        integrationId: {type: String, required:true},
        schema: {type: String, default: ""}
    },

    data() {
        return {
            myobShipmentSchemaModal: true,
        }
    },

    watch: {
        myobShipmentSchemaModal(value, oldValue) {
            if (value != oldValue) {
                this.$emit('myobShipmentSchemaModalClose')
            }
        },
    }
}
</script>